import { scaleLinear } from 'd3-scale';
import { mean } from 'lodash';
import {
  getNumberOfPointsFromDuration,
  SIDE_POINTS,
} from '../../clustering/client/helpers';
import { Cluster } from '../../clustering/clustering.types';
import { Dimension, DimensionAction } from '../types/web-gl.type';

export const dimensionReducer = (
  state: Record<number, Dimension>,
  action: DimensionAction,
) => {
  switch (action.type) {
    case 'add_dimension':
      return {
        ...state,
        ...action.payload,
      };
    case 'initialize':
    default:
      return {} as Record<number, Dimension>;
  }
};

export const measureDimension = (
  element: HTMLElement | null,
  cluster: Cluster,
  xMax: number,
  scroll: {
    x: number;
    y: number;
  },
  predicate: (action: DimensionAction) => void,
) => {
  if (element != null && cluster != null) {
    const { top, left, right } = element.getBoundingClientRect();

    const xScale = scaleLinear().domain([0, xMax]).range([left, right]);
    const offsets = cluster.beats.flatMap((beat) =>
      getNumberOfPointsFromDuration(beat.offset - beat.onset),
    );
    const rectOnset = SIDE_POINTS + 1; // we show 600 fiducial points before the beat onset
    const beatLeft = xScale(rectOnset);
    const meanOffset = mean(offsets);
    const beatRight = xScale(rectOnset + meanOffset);

    predicate({
      type: 'add_dimension',
      payload: {
        // we remove the scrolling from the new dimensions in order to reset
        // the positions so that when they get redrawn by webGL they will be correctly
        // positioned with the current scrolling
        [cluster.id]: {
          top: top - scroll.y,
          left: left - scroll.x,
          beatLeft: beatLeft - scroll.x,
          beatRight: beatRight - scroll.x,
        },
      },
    });
  }
};
